export default __webpack_public_path__ + "static/media/Logo.ad21c665.svg";